import { POST } from '../http';

export const CreateRoomKey = (spec, baseURL) => {
    return POST("", spec, baseURL + "VisionLineKeycard/Create");
}

export const CopyRoomKey = (spec, baseURL) => {
    return POST("", spec, baseURL + "VisionLineKeycard/Copy");
}